import { render } from "./Hero.vue?vue&type=template&id=033d1d6f&scoped=true"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=033d1d6f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-033d1d6f"]])

export default __exports__